import moment from 'moment'

export default {
  namespaced: true,

  state: () => ({
    selectedMerchant: null,
    merchantList: [],
    merchantLeaderboard: {
      data: [],
      links: {},
      meta: {},
    },
    showAllMerchantLeaderboard: false,
    transactionItems: {
      data: [],
      links: {},
      meta: {},
    },
    showAllTransactionItems: false,
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().endOf('month').format('YYYY-MM-DD'),
    totalReport: {},
    dailyReport: [],
    limit: 10,
    isLoadingTotalSalesReport: false,
    isLoadingDailySalesReport: false,
  }),

  getters: {
    isLoading: state => state.isLoadingTotalSalesReport || state.isLoadingDailySalesReport,
  },

  mutations: {
    SET_MERCHANT_LEADERBOARD(state, payload) {
      state.merchantLeaderboard = payload
    },
    RESET_MERCHANT_LEADERBOARD(state) {
      state.merchantLeaderboard = {
        data: [],
        links: {},
        meta: {},
      }
    },
    SET_TRANSACTION_ITEMS(state, payload) {
      state.transactionItems = payload
    },
    RESET_TRANSACTION_ITEMS(state) {
      state.transactionItems = {
        data: [],
        links: {},
        meta: {},
      }
    },
    SET_SHOW_ALL_MERCHANT_LEADERBOARD(state, payload) {
      state.showAllMerchantLeaderboard = payload
    },
    SET_SHOW_ALL_TRANSACTION_ITEMS(state, payload) {
      state.showAllTransactionItems = payload
    },
    SET_SELECTED_MERCHANT(state, merchant) {
      state.selectedMerchant = merchant
    },
    SET_MERCHANT_LIST(state, merchants) {
      state.merchantList = merchants
    },
    SET_START_DATE(state, date) {
      state.startDate = date
    },
    SET_END_DATE(state, date) {
      state.endDate = date
    },
    SET_TOTAL_REPORT(state, report) {
      state.totalReport = report
    },
    SET_DAILY_REPORT(state, report) {
      state.dailyReport = report
    },
    RESET_TOTAL_REPORT(state) {
      state.totalReport = {}
    },
    RESET_DAILY_REPORT(state) {
      state.dailyReport = []
    },
    SET_LOADING_TOTAL(state, isLoading) {
      state.isLoadingTotalSalesReport = isLoading
    },
    SET_LOADING_DAILY(state, isLoading) {
      state.isLoadingDailySalesReport = isLoading
    },
  },

  actions: {
    // get
    async fetchReports({ commit, state }) {
      if (!state.selectedMerchant || state.startDate > state.endDate) return

      commit('SET_LOADING_TOTAL', true)
      commit('SET_LOADING_DAILY', true)

      const params = {
        merchant_id: state.selectedMerchant.id,
        start_date: state.startDate,
        end_date: state.endDate,
      }

      try {
        const totalResponse = await this._vm.$http.get('/v5/report/merchant-total-sales', { params })
        commit('SET_TOTAL_REPORT', totalResponse.data.data)
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
      }

      commit('SET_LOADING_TOTAL', false)

      try {
        const dailyResponse = await this._vm.$http.get('/v5/report/merchant-daily-sales', { params })
        commit('SET_DAILY_REPORT', dailyResponse.data.data)
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
      }

      commit('SET_LOADING_DAILY', false)
    },
  },
}
